import { Component, OnInit,AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import * as $ from 'jquery';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
    ) { }

  ngOnInit() {
    this.titleService.setTitle('Trinkaについて | 学術論文、テクニカルライティングに特化したAI英文校正ツール');
    this.metaTagService.updateTag({ name: 'description', content: 'Trinka（トリンカ）は、学術論文とテクニカルライティングに特化したAI英文校正ツール。Trinka開発にいたった背景や名称の由来、そして親会社Crimson Interactiveについてご紹介します。' });
    this.metaTagService.updateTag({ name: 'keywords', content: 'テクニカルライティング,アカデミックライティング,英文チェッカー,校正ツール,AI校正ツール,AIツール,学術論文,文法チェック,文法チェックツール,英文　校正　サイト,英文校正　無料,英文チェック　サイト,Trinka,トリンカ' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinkaについて | 学術論文、テクニカルライティングに特化したAI英文校正ツール' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka（トリンカ）は、学術論文とテクニカルライティングに特化したAI英文校正ツール。Trinka開発にいたった背景や名称の由来、そして親会社Crimson Interactiveについてご紹介します。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/aboutus' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/aboutus' });
  
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/owl.carousel.min.js', function () { });
      $.getScript('../../../assets/js/about_us_testimonial_silders.js', function () { });
      $.getScript('../../../assets/js/wisepop.js', function(){});
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }
  ngAfterViewInit(){
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/branding_logo.js', function () { });
    }
  }

  

}